module.exports = __webpack_public_path__ + "img/mail-banner.2a3b0a36.png";